import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { ITPDAParticipant } from "@comunicare/comunicare-interfaces";
import moment from "moment";

export class ParticipantDataSource extends MatTableDataSourceExtended<ITPDAParticipant> {
  override sortingDataAccessor = (data: ITPDAParticipant, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "inscriptionDate":
        return moment(data.inscriptionDate).unix();
      case "identifier":
        return data.identifier;
      case "lang":
        return data.lang;
      default:
        return "";
    }
  };

  public loadData(data: ITPDAParticipant[]): void {
    this.data = data;
  }
}
